import { gql } from '@apollo/client';
import Fragments from './fragments';

export const SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_QUERY = gql`
  query scheduleTypeCellParamTemplate($scheduleTypeCellParamTemplateId: Int!) {
    scheduleTypeCellParamTemplate(scheduleTypeCellParamTemplateId: $scheduleTypeCellParamTemplateId) {
      ...scheduleTypeCellParamTemplateItem
    }
  }
  ${Fragments.scheduleTypeCellParamTemplateItem}
`;

export const SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_COLUMNS_QUERY = gql`
  query scheduleTypeCellParamTemplateColumns($scheduleTypeId: Int!) {
    scheduleTypeCellParamTemplateColumns(scheduleTypeId: $scheduleTypeId) {
      scheduleTypeCellParamId
      cellParamName
      cellParamTypeName
    }
  }
`;

export const SCHEDULE_TYPES_WITH_CELL_PARAMS = gql`
  query scheduleTypesWithCellParams {
    scheduleTypesWithCellParams {
      scheduleTypeId
      siteId
      scheduleTypeName
      isTemplate
      isActive
      cellParametrizationYN
    }
  }
`;
